import { ApiService } from './ApiService';

export interface ExecutionLog {
  id: string;
  flowId: string;
  nodeId: string;
  userId: string;
  sessionId: string;
  message: string;
  errorStack?: string;
  isError: boolean;
  userName?: string;
  createdAt: string;
  updatedAt: string;
  /** Whether this (successful) execution has a stored output. */
  hasOutput?: boolean;
  /** Id used to fetch the full output lazily via getExecutionOutput. */
  outputId?: string;
  /** Which node field the output came from: 'text' | 'result'. */
  outputType?: string;
  /** Short, truncated preview of the output shown inline in the list. */
  outputPreview?: string;
}

export interface NodeOutput {
  id: string;
  flowId: string;
  nodeId: string;
  userId: string;
  sessionId: string;
  executionLogId?: string;
  output: string;
  outputType?: string;
  isError: boolean;
  createdAt: string;
  updatedAt: string;
}

export class ExecutionLogsService extends ApiService {
  static pathName = '/executions_logs';

  static getExecutionLogs = (
    flowId: string,
    nodeId: string,
  ): Promise<ExecutionLog[]> => {
    return this.get(`${this.pathName}/nodes?flowId=${flowId}&nodeId=${nodeId}`);
  };

  /** Fetch the full output of a single execution (lazy — only when expanded/used). */
  static getExecutionOutput = (outputId: string): Promise<NodeOutput> => {
    return this.get(`${this.pathName}/output/${outputId}`);
  };
}
